<template>
  <div>
    <div v-if="totalAddressTransactions > 0">
      <b-table
        :data="addressTransactions"
        detailed
        detail-key="hash"
        class="table"
        v-bind:mobileCards="false"
      >
        <template slot-scope="props">
          <b-table-column field="hash" label="TxHash">
            <div v-if="props.row.hash && props.row.hash.length < 40">
              {{ props.row.hash }}
            </div>
            <router-link
              v-else
              class="router-link short-addr"
              :to="{ name: 'tx', params: {txhash: props.row.hash}}"
            >
              <i v-if="props.row.txStatus === 'Failure'" style="font-style:normal; color:red; margin-right:2px;">&#9432;</i>
              {{ props.row.hash }}
            </router-link>
          </b-table-column>
          <b-table-column field="blockNumber" label="Block">
            <router-link
              class="router-link"
              :to="{ name: 'block', params: {blockNumber: props.row.blockNumber}}"
            >
              {{ props.row.blockNumber }}
            </router-link>
          </b-table-column>
          <b-table-column field="timeStamp" label="Age">
            <v-tooltip bottom>
                <span slot="activator">
                    <timeago
                      :datetime="props.row.timestamp"
                      :auto-update="10">
                    </timeago>
                </span>
                <span>{{ new Date(props.row.timestamp).toISOString() }}</span>
              </v-tooltip>
          </b-table-column>
          <b-table-column field="from" label="From">
            <span class="short-addr" v-if="(address === props.row.from) || (props.row.from.length < 40)">
              {{ props.row.from }}
            </span>
            <router-link
              v-else
              class="router-link short-addr"
              :to="{ name: 'address', params: {address: props.row.from}}"
            >
              {{ props.row.from }}
            </router-link>
          </b-table-column>
          <b-table-column label="">
            <!-- <img
              class="transferIcons"
              v-if="(((props.row.to) && (address == props.row.to)) && !isContract)"
              src="@/assets/img/icons/transfer_in_to_left.png"
              alt="transfer in"
            />
            <img
              class="transferIcons"
              v-else-if="((address == props.row.from) && (props.row.to) || isContract)"
              src="@/assets/img/icons/transfer_out_to_right.png"
              alt="transfer out"
            /> -->
            {{
              (props.row.to
              && (address == props.row.to)
              && !isContract)
              ? `IN`
              : (address == props.row.from
              && (props.row.to || isContract))
              ? `OUT`
              : ''
            }}
          </b-table-column>
          <b-table-column field="to" label="To">
            <router-link
              v-if="props.row.to && (props.row.to !== address)"
              class="router-link short-addr"
              v-bind:class="{'contract-addr':props.row.isContract}"
              :to="{ name: 'address', params: {address: props.row.to}}"
            >
              {{ props.row.to }}
            </router-link>
            <span v-else-if="props.row.txType">
              {{ props.row.txType }}
            </span>
            <span class="short-addr" v-else>
              {{ props.row.to }}
            </span>

          </b-table-column>
          <b-table-column field="value" label="Value">
            {{ `${props.row.value} CMT` }}
          </b-table-column>
          <b-table-column field="value" label="TxFee">
              {{ props.row.txResult ? props.row.txResult.fee.value : "" }}
          </b-table-column>
        </template>
        <template slot="detail" slot-scope="props">
            <article class="media">
                <div class="media-content">
                    <div class="content">
                        <p>
                        <small>
                            Block:
                            <router-link
                              class="router-link"
                              :to="{ name: 'block', params: {blockNumber: props.row.blockNumber}}"
                            >
                              {{ props.row.blockNumber }}
                            </router-link>
                          </small>
                          <br>
                          <small>Gas Limit: {{ props.row.gas }}</small>
                          <br>
                          <small>Gas Price: {{ props.row.gasPrice }}</small>
                          <br>
                          <small>Nonce: {{ props.row.nonce }}</small>
                          <br>
                          <small>Transaction Index: {{ props.row.transactionIndex }}</small>
                          <br>
                        </p>
                    </div>
                </div>
            </article>
        </template>
      </b-table>

      <v-layout style="position:absolute; right:0;">
        [ <a @click="dialog = true" title="Export all records in CSV format">Download CSV Export</a> ]
        <v-dialog v-model="dialog" max-width="400">
          <v-card style="text-align:left;">
            <v-card-title class="headline">Download transactions</v-card-title>
            <v-card-text>Before continuing please verify that you are not a robot by completing the captcha below.</v-card-text>
            <v-card-actions>
              <div id="down-txs-recaptcha"></div>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-layout>

    </div>
      <Empty v-else/>
      <el-pagination
        small
        background
        @current-page="current_page"
        @current-change="shift"
        @prev-click="shift(current_page-1)"
        @next-click="shift(current_page+1)"
        layout="prev, pager, next"
        :current_page.sync="current_page"
        :pager-count=5
        :page-size="pageSize"
        :total="totalAddressTransactions">
      </el-pagination>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Empty from '../reusables/empty.vue';

export default {
  name: 'AddressTransactions',
  props: ['address', 'isContract'],
  components: {
    Empty,
  },
  data() {
    return {
      current_page: 1,
      pageSize: 10,
      dialog: false,
      recaptchaRendered: false,
      toResetRecaptcha: false,
      recaptchaId: null,
    };
  },
  computed: {
    ...mapGetters(['addressTransactions', 'totalAddressTransactions']),
  },
  watch: {
    '$route.params.address': function () {
      this.shift(1);
    },
    dialog(nv) {
      if (nv === true) {
        if (this.recaptchaRendered) {
          if (this.toResetRecaptcha) {
            window.grecaptcha.reset(this.recaptchaId);
            this.toResetRecaptcha = false;
          }
        } else {
          this.recaptchaId = window.grecaptcha.render('down-txs-recaptcha', {
            sitekey: '6Le6wFIUAAAAAPMm9nXPFR9h6gL8HRD21GpQaJxT',
            callback: this.downloadTxs,
          });
          this.recaptchaRendered = true;
        }
      }
    },
  },
  methods: {
    shift(page) {
      this.$store.dispatch('fetchAddressTransactions', {
        address: this.address,
        limit: this.pageSize,
        page,
      });
      this.current_page = page;
    },
    downloadTxs(response) {
      this.toResetRecaptcha = true;
      window.location = `${process.env.VUE_APP_API_ENDPOINT}/v3/downloadTransactionHistory?address=${this.address}&recaptcha=${response}`;
      setTimeout(() => { this.dialog = false; }, 1000);
    },
  },
  created() {
    this.shift(1);
  },
};
</script>
